import { render, staticRenderFns } from "./summary-product-item.vue?vue&type=template&id=67773fc2&scoped=true"
import script from "./summary-product-item.vue?vue&type=script&lang=ts"
export * from "./summary-product-item.vue?vue&type=script&lang=ts"
import style0 from "./summary-product-item.vue?vue&type=style&index=0&id=67773fc2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67773fc2",
  null
  
)

export default component.exports